<body>
  @if (!msalInitialized) {
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Initializing authentication...</p>
      </div>
    </div>
  }
  @if (msalInitialized) {
    <div>
      @if (authService.instance.getAllAccounts().length > 0) {
        <app-nav-menu></app-nav-menu>
      }
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
</body>